export default "__VITE_ASSET__6fb208ca__"